import { render } from "./WidgetValor.vue?vue&type=template&id=78d6e414&scoped=true&ts=true"
import script from "./WidgetValor.vue?vue&type=script&lang=ts"
export * from "./WidgetValor.vue?vue&type=script&lang=ts"

import "./WidgetValor.vue?vue&type=style&index=0&id=78d6e414&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d6e414"]])

export default __exports__